import React, { FC } from 'react';
import AccessoriesGarmentIcon from '../../../assets/garmentIcons/accessories-garment.svg';
import BeltGarmentIcon from '../../../assets/garmentIcons/belt-garment.svg';
import FootwearGarmentIcon from '../../../assets/garmentIcons/footwear-garment.svg';
import FullbodyGarmentIcon from '../../../assets/garmentIcons/fullbody-garment.svg';
import GlovesGarmentIcon from '../../../assets/garmentIcons/gloves-garment.svg';
import HeadgearGarmentIcon from '../../../assets/garmentIcons/headgear-garment.svg';
import JumperGarmentIcon from '../../../assets/garmentIcons/jumper-garment.svg';
import OtherGarmentIcon from '../../../assets/garmentIcons/other-garment.svg';
import OuterwearGarmentIcon from '../../../assets/garmentIcons/outerwear-garment.svg';
import ShirtGarmentIcon from '../../../assets/garmentIcons/shirt-garment.svg';
import ShortsGarmentIcon from '../../../assets/garmentIcons/shorts-garment.svg';
import SkirtGarmentIcon from '../../../assets/garmentIcons/skirt-garment.svg';
import TrousersGarmentIcon from '../../../assets/garmentIcons/trousers-garment.svg';
import TshirtGarmentIcon from '../../../assets/garmentIcons/tshirt-garment.svg';

interface GarmentIconProps {
    garment: string;
}

const GarmentIcon: FC<GarmentIconProps> = ({ garment }) => {
    switch (garment) {
        case 'Accessories':
            return <AccessoriesGarmentIcon data-testid="GarmentIcon" />;
        case 'Belt':
            return <BeltGarmentIcon />;
        case 'Footwear':
            return <FootwearGarmentIcon />;
        case 'FullBody':
            return <FullbodyGarmentIcon />;
        case 'Gloves':
            return <GlovesGarmentIcon />;
        case 'headgearGarment':
            return <HeadgearGarmentIcon />;
        case 'Jumper':
            return <JumperGarmentIcon />;
        case 'Outerwear':
            return <OuterwearGarmentIcon />;
        case 'Shirt':
            return <ShirtGarmentIcon />;
        case 'Shorts':
            return <ShortsGarmentIcon />;
        case 'Skirt':
            return <SkirtGarmentIcon />;
        case 'Trousers':
            return <TrousersGarmentIcon />;
        case 'TShirt':
            return <TshirtGarmentIcon />;
        case 'Other':
        default:
            return <OtherGarmentIcon />;
    }
};

export default GarmentIcon;
